<!--HEADER-->
<ion-grid class="pageContainers backgroundWhite" [ngClass]="configService?.queryParams?.hideHeader ? 'hideHeader' : ''">
  <ion-row class="spaceBetween">
    <!--LOGO AND CATEGORIES-->
    <ion-col size-xs="6" size-md="3"
      [ngClass]="configService?.queryParams?.hideLogo ? 'mobileSmallCategoriesMenu' : ''">
      <div class="verticalCenter justifyContentStart fullHeight">
        <!-- <img (click)="goToRoot()"  class="clickable logo" src="assets/icon/logo-ajover.png"> -->
        <div class="hideOnMobile logoCompanyContainer" *ngIf="!configService?.queryParams?.hideLogo">
          <img (click)="goToRoot()" class="clickable logo" [src]="configService.company_info?.logo">
        </div>
        <div *ngIf="!inAuthPage && configService.company_info?.show_products" [matMenuTriggerFor]="categoriesMenu"
          class="absoluteCenter logoContainer clickable fullHeight">
          <img src="assets/icon/menu-icon.png">
          <span class="hideOnMobile">Catálogo</span>
        </div>
        <mat-menu #categoriesMenu="matMenu" yPosition="above">
          <button (click)="goToPage('productos')" mat-menu-item>Ver Todos</button>
          <button *ngIf="authService.isLogged && canShowPromotion" (click)="openPromotions('productos')"
            mat-menu-item><b>En promoción</b></button>
          <button class="product-category" (click)="openCategory(category)" mat-menu-item
            *ngFor="let category of categories">{{category.name}}</button>
        </mat-menu>
        <div class="hideOnDesktop" *ngIf="!configService?.queryParams?.hideLogo">
          <img (click)="goToRoot()" class="clickable logo" [src]="configService.company_info?.logo">
        </div>
      </div>
    </ion-col>
    <!--SEARCHBAR-->
    <ion-col *ngIf="!inAuthPage" size-md="6" class="reverseFlex horizontalCenter hideOnMobile">
      <div class="searchbarContainer" *ngIf="configService.company_info?.show_products">
        <mat-form-field (keyup.enter)="searchProducts()" appearance="none">
          <input matInput
            [placeholder]="productService.current_category ? 'Buscar en ' + productService.current_category.name : 'Buscar'"
            [(ngModel)]="productName" [matAutocomplete]="auto" (input)="onChangeSearchbar($event.target.value)" />
          <mat-autocomplete class="searchbarAutocomplete" #auto="matAutocomplete">
            <mat-option *ngIf="!loadingProducts && products.length == '0'">
              No hay sugerencias
            </mat-option>
            <mat-option *ngIf="loadingProducts">
              <ion-spinner></ion-spinner>
            </mat-option>
            <ng-container *ngIf="!loadingProducts">
              <mat-option (click)="openProductDetail(product)" class="clickable" *ngFor="let product of products"
                [value]="product.name">
                {{product.name}}
              </mat-option>
            </ng-container>

          </mat-autocomplete>
        </mat-form-field>

        <ion-icon (click)="searchProducts()" color="primary" class="clickable"
          src="assets/icon/search-icon.svg"></ion-icon>
      </div>
      <div class="callToActionContainer" *ngIf="showCallToActionContainer">
        <span [style.background-color]="variant.primary_color" *ngFor="let variant of filteredVariants"
          (click)="goToVariant(variant.domain)">
          <b>Ir a {{variant.name}}</b>
        </span>
        <span *ngIf="configService?.company_info?.wallet_active"
          [style.background-color]="configService.company_info.primary_color" (click)="openWallet()">Ir a mi
          billetera</span>
        <span *ngIf="configService?.company_info?.wallet_active && configService?.company_info?.wallet_product_id"
          [style.background-color]="configService.company_info.primary_color" (click)="goToWalletProduct()">Recarga tú
          billetera</span>

        <span *ngFor="let iaTemplate of iaTemplates" (click)="openIaModal(iaTemplate)">
          <b>{{getTemplateName(iaTemplate)}}</b>
        </span>

        <span
          *ngIf="configService?.company_info?.wallet_active && configService?.company_info?.wallet_automatic_redemption"
          (click)="showActivateButton()">{{activateAutomaticPointsText}}</span>


        <span *ngIf="configService?.company_info?.modules_enabled.indexOf('COUPONS') != -1"
          (click)="openCouponPopup()">¡Tengo un Cupón!</span>


        <span *ngFor="let button of filteredCallToActions" (click)="goToPage(button.path)">{{button.name}}</span>


        <span *ngIf="configService?.company_info?.redirect_url_button" (click)="redirectToUrl()">{{
          this.configService.company_info.redirect_url_button }}</span>


        <span *ngIf="metasButton" (click)="navigateToMetas()">Metas</span>
        
        <span *ngIf="rankingResponse?.ranking" (click)="navigateToRanking()">{{ rankingResponse?.ranking?.name }}</span>
      </div>

    </ion-col>

    <!--PROFILE AND SHOPPING-->
    <ion-col *ngIf="authService.isLogged" size-xs="6" size-md="3" class="justifyContentEnd ion-no-padding"
      [ngClass]="configService?.queryParams?.hideLogo ? 'mobileBigProfileMenu' : ''">
      <div [matMenuTriggerFor]="profileMenu" class="absoluteCenter buttonRight profileButton clickable">
        <div class="verticalCenter">
          <p *ngIf="playerData" class="playerName">Hola, {{playerData?.user.first_name}}</p> <ion-skeleton-text
            *ngIf="!playerData" animated></ion-skeleton-text> <ion-icon color="primary"
            name="chevron-down-outline"></ion-icon>
        </div>
        <div class="absoluteCenter whiteArrowIcon">
          <ion-icon color="light" *ngIf="configService.company_info?.currency_icon_svg"
            [src]="configService.company_info?.currency_icon_svg"></ion-icon>
          <p class="priceText" *ngIf="playerData && configService.company_info?.show_points">{{playerData?.points |
            currency : 'COP':''}} <span
              *ngIf="!configService.company_info?.currency_icon_svg">{{configService.company_info.points_name}}</span>
          </p>
          <ion-skeleton-text *ngIf="!playerData" animated></ion-skeleton-text>
        </div>
      </div>
      <mat-menu #profileMenu="matMenu" yPosition="above">
        <span [ngClass]="getCustomCss()">
          <ng-container *ngFor="let option of profileMenuOptions">
            <button class="profile-option" [id]="getIdName(option)" *ngIf="isPageActive(option)"
              (click)="goToPage('perfil',option)" mat-menu-item>{{option}}</button>
          </ng-container>
          <!-- <button mat-menu-item (click)="openMyMissions()">Mis misiones</button>  -->
          <button *ngIf="isRTC" class="profile-option" mat-menu-item (click)="goToPage('trade-representative')">Nit
            asociados</button>
          <!-- <button *ngIf="isCOOR" class="profile-option" mat-menu-item (click)="goToPage('dependents')">Mis
          dependientes</button> -->
          <button *ngIf="showWallet" class="profile-option" mat-menu-item (click)="openWallet()">Mi billetera</button>
          <button *ngIf="showNews" class="profile-option" mat-menu-item (click)="openNews()">Noticias</button>
          <button class="profile-option" mat-menu-item
            *ngIf="configService?.company_info?.modules_enabled.indexOf('SOCIAL') != -1 || showSocialFeed"
            (click)="openFeed()">Muro</button>
          <button class="profile-option" (click)="openMission(mission.id)" mat-menu-item
            *ngFor="let mission of missionsOnMenu">{{mission.item_menu}}</button>
          <button class="profile-option" (click)="openMissionResponses(mission)" mat-menu-item
            *ngFor="let mission of missionsResponseOnMenu">{{mission.response_item_menu}}</button>
          <button class="profile-option" (click)="openKpi(kpi)" mat-menu-item
            *ngFor="let kpi of kpiOnMenu">{{kpi.name}}</button>
          <button class="profile-option" *ngIf="!configService?.queryParams?.hideLogout" (click)="logout()"
            mat-menu-item>Cerrar sesión</button>
        </span>
      </mat-menu>
      <div [matMenuTriggerFor]="notificationMenu" class="absoluteCenter buttonRight shoppingButton clickable"
        title="Notificaciones">
        <div class="positionRelative">
          <ion-icon color="primary" src="assets/icon/notification.svg"></ion-icon>
          <ion-badge *ngIf="this.socketService.number_alerts > 0"
            color="secondary">{{this.socketService.number_alerts}}</ion-badge>
        </div>
        <mat-menu #notificationMenu="matMenu" yPosition="above">
          <button (click)="openAlert(alert)" *ngFor="let alert of this.socketService.alerts" class="notification-button"
            [ngClass]="alert.was_seen ? '' : 'notSeen'" mat-menu-item>
            <span>{{alert.alert.title}}</span> <br>
            <span>{{alert.alert.description}}</span>
          </button>
          <button (click)="goToPage('perfil', 'Notificaciones')" mat-menu-item>Ver Todas...</button>
        </mat-menu>
      </div>
      <div class="absoluteCenter buttonRight shoppingButton clickable" title="Carrito de Compras">
        <div class="positionRelative" (click)="goToPage('carrito-de-compras')">
          <ion-icon color="primary" src="assets/icon/cart-icon.svg"></ion-icon>
          <ion-badge *ngIf="productService?.shooping_cart.length > 0"
            color="secondary">{{productService?.shooping_cart.length}}</ion-badge>
        </div>
      </div>

    </ion-col>
    <!--AUTH BUTTONS-->
    <ion-col *ngIf="!authService.isLogged" size-xs="6" offset-md="1" size-md="2" class="justifyContentEnd">
      <div class="clickable absoluteCenter enterButton" (click)="scrollTo('login')">
        <span class="fontPoppins">Ingresar</span>
      </div>
      <div class="clickable absoluteCenter" (click)="scrollTo('signup')">
        <span class="fontPoppins">Registrarse</span>
      </div>
    </ion-col>
    <!--SEARCHBAR-->
    <ion-col *ngIf="!inAuthPage" size-md="6" class="reverseFlex horizontalCenter showOnMobile">
      <div class="searchbarContainer">
        <mat-form-field (keyup.enter)="searchProducts()" appearance="none">
          <input matInput
            [placeholder]="productService.current_category ? 'Buscar en ' + productService.current_category.name : 'Buscar'"
            [(ngModel)]="productName" [matAutocomplete]="auto" (input)="onChangeSearchbar($event.target.value)" />
          <mat-autocomplete class="searchbarAutocomplete" #auto="matAutocomplete">
            <mat-option *ngIf="!loadingProducts && products.length == '0'">
              No hay sugerencias
            </mat-option>
            <mat-option *ngIf="loadingProducts">
              <ion-spinner></ion-spinner>
            </mat-option>
            <ng-container *ngIf="!loadingProducts">
              <mat-option (click)="openProductDetail(product)" class="clickable" *ngFor="let product of products"
                [value]="product.name">
                {{product.name}}
              </mat-option>
            </ng-container>

          </mat-autocomplete>
        </mat-form-field>

        <ion-icon (click)="searchProducts()" color="primary" class="clickable"
          src="assets/icon/search-icon.svg"></ion-icon>
      </div>
      <div class="callToActionContainer" *ngIf="showCallToActionContainer">
        <span [style.background-color]="variant.primary_color" *ngFor="let variant of filteredVariants"
          (click)="goToVariant(variant.domain)">
          <b>Ir a {{variant.name}}</b>
        </span>

        <span *ngIf="configService?.company_info?.wallet_active"
          [style.background-color]="configService.company_info.primary_color" (click)="openWallet()">
          Ir a mi billetera
        </span>

        <span *ngIf="configService?.company_info?.wallet_active && configService?.company_info?.wallet_product_id"
          [style.background-color]="configService.company_info.primary_color" (click)="goToWalletProduct()">
          Recarga tú billetera
        </span>

        <span *ngFor="let iaTemplate of iaTemplates" (click)="openIaModal(iaTemplate)">
          <b>{{getTemplateName(iaTemplate)}}</b>
        </span>

        <span
          *ngIf="configService?.company_info?.wallet_active && configService?.company_info?.wallet_automatic_redemption"
          (click)="showActivateButton()">{{activateAutomaticPointsText}}</span>

        <span *ngIf="configService?.company_info?.modules_enabled.indexOf('COUPONS') != -1"
          (click)="openCouponPopup()">¡Tengo un Cupón!</span>
        <span *ngFor="let button of filteredCallToActions" (click)="goToPage(button.path)">{{button.name}}</span>

        <span *ngIf="configService?.company_info?.redirect_url_button" (click)="redirectToUrl()">{{
          this.configService.company_info.redirect_url_button }}</span>

        <span *ngIf="rankingResponse?.ranking" (click)="navigateToRanking()">{{ rankingResponse?.ranking?.name }}</span>

      </div>
    </ion-col>

  </ion-row>
</ion-grid>